import { GateMainMenuComponent } from './gate-main-menu/gate-main-menu';
import { GateAppComponent } from './gate-app/gate-app';

export const components: any[] = [GateMainMenuComponent, GateAppComponent];
